import jwtAuthService from "../../services/jwtAuthService";
import history from "../../history.js";

export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SIGNUP_SUCCESS_RESPONSE = "SIGNUP_SUCCESS_RESPONSE";
export const SIGNUP_LOADING = "SIGNUP_LOADING";
export const VERIFY_ERROR = "SIGNUP_ERROR";
export const VERIFY_SUCCESS_RESPONSE = "SIGNUP_SUCCESS_RESPONSE";
export const VERIFY_LOADING = "SIGNUP_LOADING";



export function signupErrorResponse(error) {
  return {
    type: SIGNUP_ERROR,
    ...error,
  };
}

export function verifyErrorResponse(error) {
  return {
    type: VERIFY_ERROR,
    ...error,
  };
}


export function signupResponse(response) {
  return {
    type: SIGNUP_SUCCESS_RESPONSE,
    response,
  };
}

export function verifyResponse(response) {
  return {
    type: VERIFY_SUCCESS_RESPONSE,
    response,
  };
}

export function signUpService({ firstname, lastname, email, password }) {
  return dispatch => {
    dispatch({
      type: SIGNUP_LOADING
    });

    jwtAuthService
      .signUpService(firstname, lastname, email, password)
      .then(user => {

        const response = {}
        response.notification = {
          level: 'success',
          message: 'User successfully registered',
        };
        return dispatch(signupResponse(response));
      })
      .catch(error => {

       return dispatch(signupErrorResponse({ error }));
        
      });
  };
}

export function verifyService({ email, secretToken }) {
  return dispatch => {
    dispatch({
      type: VERIFY_LOADING
    });

    jwtAuthService
      .verifyService(email, secretToken)
      .then(user => {

        history.push({
          pathname: "/session/signin"
        });

        const response = {}
        response.notification = {
          level: 'success',
          message: 'User successfully verified',
        };
        return dispatch(verifyResponse(response));
      })
      .catch(error => {

       return dispatch(verifyErrorResponse({ error }));
        
      });
  };
}

